import { render } from "./send-template.vue?vue&type=template&id=323d408c"
import script from "./send-template.vue?vue&type=script&lang=js"
export * from "./send-template.vue?vue&type=script&lang=js"

import "./send-template.vue?vue&type=style&index=0&id=323d408c&lang=postcss"
script.render = render

export default script